import React from 'react';
import {formatCurrency} from '~/utils';
import './BillPrint.scss';

const BillPrint = React.forwardRef(({billData}, ref) => {
    const {
        code,
        date,
        cashier,
        customer,
        address,
        phone,
        items,
        subtotal,
        totalVat,
        discountAmount,
        discountType,
        discount,
        shipping,
        total,
        paid,
        change
    } = billData;

    const {appData} = React.useContext(require('~/context/AppProvider').AppContext);

    return (
        <div ref={ref} className="bill-print">
            <div className="bill-container">
                {/* Header */}
                <div className="bill-header">
                    <div className="store-name">GIÒ CHẢ TUYẾT</div>
                    <div className="store-info">Website: giochatuyet.com</div>
                    <div className="store-info">330 Bùi Hữu Nghĩa, P Gia Định, Bình Thạnh</div>
                    <div className="store-info">MST: 079200018887</div>
                    <div className="store-info">Hotline: 0984974067 - 0983960267</div>
                    <div className="store-info">Tuyết: 0903658721 - Trân: 0775776422</div>
                    <div className="store-info">Ngày : {date}</div>
                </div>
                {/* Bill Info */}
                <div className="bill-info">
                    <div className="info-row">
                        <span>Đơn hàng:</span>
                        <span>{code}</span>
                    </div>
                    <div className="info-row">
                        <span>Nhân viên:</span>
                        <span>{cashier}</span>
                    </div>
                    {customer && (
                        <div className="info-row">
                            <span>Khách hàng:</span>
                            <span>{customer}</span>
                        </div>
                    )}
                    {phone && (
                        <div className="info-row">
                            <span>Điện thoại:</span>
                            <span>{phone}</span>
                        </div>
                    )}
                    {address && (
                        <div className="info-row">
                            <span>Địa chỉ:</span>
                            <span>{address}</span>
                        </div>
                    )}
                </div>

                <div className="bill-divider"></div>

                {/* Items */}
                <div className="bill-items">
                    {items && items.map((item, index) => {
                        // Calculate item total: price * quantity (already handled correctly)
                        const rawQty = (item.unit === 'kg') ? (item.quantity/1000).toFixed(2) : item.quantity;
                        const quantity = (typeof rawQty === 'string' && rawQty.endsWith('.00')) ? rawQty.slice(0, -3) : rawQty;

                        const itemTotal = ((item.unit === 'kg') ? item.price*10 : item.price ) * quantity;

                        return (
                            <div key={index} className="bill-item">
                                <div className="item-name">
                                    {item.title || item.product_name}
                                    {item.attribute_label && <span className="item-variant"> ({item.attribute_label})</span>}
                                </div>
                                <div className="item-detail">
                                    <span className="item-qty">
                                        {quantity} {appData['units'][item.unit]?.label} x {formatCurrency(((item.unit === 'kg') ? item.price*10 : item.price ))}
                                    </span>
                                    <span className="item-total">
                                        {formatCurrency(itemTotal)}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="bill-divider"></div>

                {/* Summary */}
                <div className="bill-summary">
                    <div className="summary-row">
                        <span>Tạm tính:</span>
                        <span>{formatCurrency(subtotal)}</span>
                    </div>
                    {totalVat > 0 && (
                        <div className="summary-row">
                            <span>VAT:</span>
                            <span>{formatCurrency(totalVat)}</span>
                        </div>
                    )}
                    {discountAmount > 0 && (
                        <div className="summary-row">
                            <span>
                                Chiết khấu {discountType === 'percent' ? ` (${discount}%)` : ''}:
                            </span>
                            <span>-{formatCurrency(discountAmount)}</span>
                        </div>
                    )}
                    {shipping > 0 && (
                        <div className="summary-row">
                            <span>Phí vận chuyển:</span>
                            <span>{formatCurrency(shipping)}</span>
                        </div>
                    )}

                    <div className="summary-row total-row">
                        <span>Tổng:</span>
                        <span>{formatCurrency(total)}</span>
                    </div>

                    <div className="summary-row">
                        <span>Khách đưa:</span>
                        <span>{formatCurrency(paid)}</span>
                    </div>
                    <div className="summary-row">
                        <span>Thối lại:</span>
                        <span>{formatCurrency(change)}</span>
                    </div>
                </div>
                {/* Footer */}
                <div className="bill-footer">
                    <div className="thank-you">Cam on quy khach!</div>
                    <div className="visit-again">Hen gap lai!</div>
                </div>
            </div>
        </div>
    );
});

BillPrint.displayName = 'BillPrint';

export default BillPrint;
